import { render, staticRenderFns } from "./kamiInfo.vue?vue&type=template&id=93e02a84&scoped=true"
import script from "./kamiInfo.vue?vue&type=script&lang=js"
export * from "./kamiInfo.vue?vue&type=script&lang=js"
import style0 from "./kamiInfo.vue?vue&type=style&index=0&id=93e02a84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e02a84",
  null
  
)

export default component.exports